import * as React from "react";

import $ from "jquery";
import * as _ from "lodash";

import CheckboxTree from "../../../../../node_modules/react-checkbox-tree/lib/"; // Using fork of react-checkbox-tree at github:MikeAtWest/react-checkbox-tree

import { ICalendarPage, IServer, ITreeViewNode } from "../../classes/state";
import { IText, IText_SelectEvents } from "../../classes/text";

import PaginatorComponent from "../../../common/paginator/paginatorComponent";
import { DataService } from "../../data/DataService";
import { SelectEventsUtilities } from "./SelectEventsUtilities";

import "../../../common/styles/treeview.css";

export interface ISelectEventsControlProps {
  calendarId: number;
  childServerIds: number;
  currentServerId: number;
  parentServerId: number;
  portletInstanceId: number;
  rootServerId: number;
  servers: IServer[];
  checkedNodeItemIds: string[];
  checkedNodeCalendarIds: string[];
  expandedNodeItemIds: string[];
  text: IText;
  currentPageNumber: number;
  onCloseModal: (event: any) => any;
  updateCheckedNodeItemIds(checkedNodeItemIds: string[]): void;
  updateCheckedNodeCalendarIds(checkedNodeCalendarIds: string[]): void;
  updateExpandedNodeItemIds(expandedNodeItemIds: string[]): void;
  updateServersSitesPagesAndCalendars(servers: IServer[]): void;
  updateCurrentPageNumber(pageNumber: number): void;
}

export interface ISelectEventsControlState {
  servers: IServer[];
  treeViewNodes: ITreeViewNode[];
  checkedNodeItemIds: string[];
  checkedNodeCalendarIds: string[];
  expandedNodeItemIds: string[];
  pageNumber: number;
}

export class SelectEventsControl extends React.Component<ISelectEventsControlProps, ISelectEventsControlState> {

  private utils: SelectEventsUtilities = new SelectEventsUtilities();
  private recordsPerPage = 6;
  private numberOfPageLinks = 5;

  public constructor(props: any, context: any) {
    super(props, context);

    this.setUpInitialLocalState(props);
    this.bindEvents();
  }

  public render() {

    const totalNumberOfServers = this.state.servers.length;
    const descOfCalendarsSelected = this.getDescriptionOfSelectedCalendars(this.props.text.selectEvents);

    const text = this.props.text.selectEvents;

    return (
      <div className="CAL_modalContent">

        <div className="CAL_modalCount">{descOfCalendarsSelected}</div>

        {/*<div>checkedNodeItemIds: {this.state.checkedNodeItemIds.toString()}</div>
        <div>checkedNodeCalendarIds: {this.state.checkedNodeCalendarIds.toString()}</div>
        <div>expandedNodeItemIds: {this.state.expandedNodeItemIds.toString()}</div>*/}

        <CheckboxTree
          checked={this.state.checkedNodeItemIds}
          expanded={this.state.expandedNodeItemIds}
          nodes={this.state.treeViewNodes}
          onCheck={this.onCheckTreeViewNode}
          onExpand={this.onExpandTreeViewNode}
          noCascade={true}
          onlyCascadeDown={true}
        />

        <PaginatorComponent
          totalNumberOfRecords={totalNumberOfServers}
          recordsPerPage={this.recordsPerPage}
          numberOfPageLinks={this.numberOfPageLinks}
          currentPageNumber={this.state.pageNumber}

          text_currentlyDisplayingPage={text.pager_currentlyDisplayingPage}
          text_displayPage={text.pager_displayPage}
          text_displayPreviousPageOfResults={text.pager_displayPreviousPageOfResults}
          text_displayPreviousSetOfPageLinks={text.pager_displayPreviousSetOfPageLinks}
          text_displayNextPageOfResults={text.pager_displayNextPageOfResults}
          text_displayNextSetOfPageLinks={text.pager_displayNextSetOfPageLinks}

          text_noNextPageOfResults={text.pager_noNextPageOfResults}
          text_noNextSetOfPageLinks={text.pager_noNextSetOfPageLinks}
          text_noPreviousPageOfResults={text.pager_noPreviousPageOfResults}
          text_noPreviousSetOfPageLinks={text.pager_noPreviousSetOfPageLinks}

          text_of={text.pager_of}
          text_ofResultsText={text.pager_ofResults}

          onChangePage={this.onChangePage}
        />

        <div className="CAL_modalControls">
          <button onClick={this.onViewSelectedCalendars} className="CMS_button">{text.viewSelectedCalendars}</button>
          <button onClick={this.onUncheckAllCalendars} className="CMS_button CMS_bCancel">{text.clearAllSelectedCalendars}</button>
        </div>

      </div>
    );
  }

    public componentDidMount() {
    this.addJQueryTweaks();
  }

  public componentDidUpdate() {
    this.addJQueryTweaks();
  }

  private addJQueryTweaks() {
    this.setUndisplayedTreeViewNodesToNoTabIndex();
    this.suppressSubmittingFormOnPressEnterKeyOnCheckboxes();
  }

  private setUndisplayedTreeViewNodesToNoTabIndex() {
    // Mac Safari browser gets stuck in a TAB trap in the display=none treeview nodes (used for pagination). This hack sets the tabIndex on those nodes to -1.
    $("li.treeNode_Server button").removeAttr("tabindex");
    $("li.treeNode_NoDisplay button").attr("tabindex", "-1");
  }

  private suppressSubmittingFormOnPressEnterKeyOnCheckboxes() {
    $("div.react-checkbox-tree input:checkbox").keypress((event) => {
      if (event.keyCode === 10 || event.keyCode === 13) { event.preventDefault(); }
    });
  }

  private setUpInitialLocalState(props: ISelectEventsControlProps) {

    // Create copies of data from props, and set in local state.

    const servers: IServer[] = _.map(props.servers, _.cloneDeep);

    let treeViewNodes: ITreeViewNode[] = this.utils.createServerTreeNodes(this.props.servers, this.recordsPerPage, this.props.currentPageNumber, this.props.text.selectEvents);

    treeViewNodes = this.setServersToDisplayOnlyThisPageOfServers(treeViewNodes, this.props.currentPageNumber);

    let checkedNodeItemIds: string[] = [];
    if (props.checkedNodeItemIds.length > 0) { checkedNodeItemIds = props.checkedNodeItemIds.slice(0); }

    let checkedNodeCalendarIds: string[] = [];
    if (props.checkedNodeCalendarIds.length > 0) { checkedNodeCalendarIds = props.checkedNodeCalendarIds.slice(0); }

    let expandedNodeItemIds: string[] = [];
    if (props.expandedNodeItemIds.length > 0) { expandedNodeItemIds = props.expandedNodeItemIds.slice(0); }

    const pageNumber = this.props.currentPageNumber;

    this.state = { servers, treeViewNodes, checkedNodeItemIds, checkedNodeCalendarIds, expandedNodeItemIds, pageNumber };
  }

  // Event handlers:

  private bindEvents() {
    this.onUncheckAllCalendars = this.onUncheckAllCalendars.bind(this);
    this.onViewSelectedCalendars = this.onViewSelectedCalendars.bind(this);
    this.onCheckTreeViewNode = this.onCheckTreeViewNode.bind(this);
    this.onExpandTreeViewNode = this.onExpandTreeViewNode.bind(this);

    this.onChangePage = this.onChangePage.bind(this);
  }

  private onUncheckAllCalendars(event: any) {
    event.preventDefault();
    this.setState({ checkedNodeItemIds: [], checkedNodeCalendarIds: [] });
  }

  private onViewSelectedCalendars(event: any) {
    event.preventDefault();

    this.props.updateServersSitesPagesAndCalendars(this.state.servers);
    this.props.updateCheckedNodeItemIds(this.state.checkedNodeItemIds);
    this.props.updateCheckedNodeCalendarIds(this.state.checkedNodeCalendarIds);
    this.props.updateExpandedNodeItemIds(this.state.expandedNodeItemIds);

    this.props.updateCurrentPageNumber(this.state.pageNumber);

    this.props.onCloseModal(event);
  }

  private onCheckTreeViewNode(checkedNodeItemIds: string[]) {

    const portletInstanceId = this.props.portletInstanceId;

    // Update the checked nodes.
    const servers: IServer[] = _.map(this.state.servers, _.cloneDeep);
    const checkedNodeCalendarIds = this.utils.getCheckedNodeCalendarIdsForServers(servers, checkedNodeItemIds);
    this.setState({ checkedNodeItemIds, checkedNodeCalendarIds });
  }

  private onExpandTreeViewNode(newExpandedNodeItemIds: string[]) {

    // Find if a server node has been expanded (rather than unexpanded).
    const currentExpandedNodeItemIds: string[] = this.state.expandedNodeItemIds;
    const addedExpandedNodeItemIds: string[] = newExpandedNodeItemIds.filter((item) => currentExpandedNodeItemIds.indexOf(item) === -1);

    // If the expanded node has not already had its sites>pages>calendars requested, request them.
    if (addedExpandedNodeItemIds.length > 0) {
      const expandedNodeItemId = Number(addedExpandedNodeItemIds[0]);

      for (const server of this.state.servers) {
        if (server.serverId === expandedNodeItemId) {
          if (server.calendarPages === null) {
            this.requestCalendarPagesForServer(expandedNodeItemId, this.props.calendarId);
            break;
          }
        }
      }

    }

    this.setState({ expandedNodeItemIds: newExpandedNodeItemIds });
  }

  private onChangePage(pageNumber: number) {
    const treeViewNodes = this.setServersToDisplayOnlyThisPageOfServers(this.state.treeViewNodes, pageNumber);
    this.setState({ pageNumber, treeViewNodes });
  }

  private setServersToDisplayOnlyThisPageOfServers(rawTreeViewNodes: ITreeViewNode[], pageNumber: number): ITreeViewNode[] {
    // Set only the nodes from the current page to display.
    const treeViewNodes: ITreeViewNode[] = _.map(rawTreeViewNodes, _.cloneDeep);
    for (const node of treeViewNodes) {
      if (node.pageNumber === pageNumber) {
        node.className = "treeNode_Server";
      } else {
        node.className = "treeNode_NoDisplay";
      }
    }
    return treeViewNodes;
  }

  private requestCalendarPagesForServer(serverId: number, calendarId: number): any {
    // This is a little unorthodox... requesting the calendarPages directly here and putting in local state, instead of requesting it through Redux
    // and putting it into global state. This local state will be added back to the global state via Redux when calling updateOpenAndSelectedServersAndCalendars().

    const dataService = new DataService();

    return dataService.calendarPagesForServer(this.props.portletInstanceId, serverId, calendarId).then((response: any) => {

      if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.

      // Update server that was clicked in servers>sites>pages>calendars data structure with the sites>pages>calendars returned.
      const servers: IServer[] = _.map(this.state.servers, _.cloneDeep);
      for (const server of servers) {
        if (server.serverId === serverId) {
          server.calendarPages = response.calendarPages;
        }
      }

      this.setState({ servers });

      // Update the tree view nodes with the same new data.
      const treeViewNodes: ITreeViewNode[] = _.map(this.state.treeViewNodes, _.cloneDeep);
      for (const node of treeViewNodes) {
        if (node.value === serverId.toString()) {
          node.children = this.utils.convertCalendarPagesToTreeViewNodes(serverId, response.calendarPages, node.nodeType, this.props.text.selectEvents);
        }
      }

      this.setState({ treeViewNodes });
    });
  }

  private getDescriptionOfSelectedCalendars(text: IText_SelectEvents): string {
    let message = "";
    const checkedNodeCalendarIds = this.state.checkedNodeCalendarIds;
    const numSelectedCalendars = checkedNodeCalendarIds.length;

    if (numSelectedCalendars > 0) {
      message = text.youHaveSelected + " " + numSelectedCalendars + " ";
      if (numSelectedCalendars > 1) {
        message += text.calendarPlural;
      } else {
        message += text.calendarSingular;
      }
      message += ".";
    } else {
      message = text.youHaveSelected + " " + text.no + " " + text.calendarPlural + ".";
    }

    return message;

  }

};
